import React, { Fragment } from 'react';
import { DataTable, DataTableConstant, TableToolType, TableRowAction } from 'hub-dashboard-framework'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

import * as HubUserBoardActions from 'store/actions/HubUserBoardActions'
import * as HubConfigActions from 'store/actions/HubConfigActions'
import authService from 'components/api-authorization/AuthorizeService';

import * as HubConstant from 'util/HubConstant';
import Utilities, { UtilConstant } from 'hub-utilities';
import { faUsers } from '@fortawesome/free-solid-svg-icons';

import * as Logger from 'loglevel';
import * as _ from 'lodash'
import 'styles/main-content/Users.scss';

import { faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { onClickDownloadCSVButton, mapMetricsDetailsToTableData, initializeMetricDetailsHeader, mapCSVData } from 'util/DataRenderHelper'

class CategoryMetricsTable extends React.Component {
    constructor(props) {
        super(props);
        this.headerConfig = {
            Category: { val: "", canSort: true },
            ... initializeMetricDetailsHeader(props.metricsReportType)
        };
        this.state = {
            fetchedData: []
        }
    }

    componentDidMount() {
        Logger.debug(this.props.metrics);
        this.setState({ fetchedData: this.fetchData(this.props.metrics) })
    }

    componentWillReceiveProps(nextPropsFromRedux) {
        if (!_.isEqual(nextPropsFromRedux.metrics, this.props.metrics)
            || this.props.action != nextPropsFromRedux.action) {
            this.setState({ fetchedData: this.fetchData(nextPropsFromRedux.metrics) })
        }
    }

    fetchData(objects) {
        if (objects !== undefined && objects != null && objects.length > 0) {
            return objects.sort((a, b) => { return (a.id < b.id) ? 1 : -1 }).map((o) => {
                return (
                    {
                        //Lower case keys won't get posted to table
                        Category: { val: o.category, canSort: true },
                        ... mapMetricsDetailsToTableData(o.metrics, this.props.metricsReportType)
                    }
                );
            })
        } else {
            return [];
        }
    }

    displayDatatable() {
        return (
            <Row className="tableRow">
                <Col xs="12">
                    <DataTable
                        headerConfig={this.headerConfig}
                        data={this.state.fetchedData}
                        tools={[
                            { action: TableToolType.PAGINATION }, 
                            { action: TableToolType.FILTER_SEARCH },
                            { 
                                action: TableToolType.CUSTOMIZED_BUTTON, 
                                tooltipName: 'Download CSV', 
                                buttonIcon: faFileDownload, 
                                onClick: () => onClickDownloadCSVButton("newshub_metrics_category", mapCSVData(this.props.metricsReportType, this.props.metrics))
                            },
                        ]}
                        canDeleteRow={false}
                        numOfRowsPerPage={5}
                        authorizeService={authService}
                        {...this.props}></DataTable>
                </Col>
            </Row>
        )
    }

    render() {
        //DataTable happens during component will mount, make sure that data is fetched before table is rendered:
        return (
            <div className="DateMetricsTable">
                <Row className="structureRow">
                    <Col xs="12">
                        {(!!this.state.fetchedData) ? this.displayDatatable() : <Fragment key="0"></Fragment>}
                    </Col>
                </Row>
            </div>
        )
    }
}

export default CategoryMetricsTable;
